import { Component, inject, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Referential } from 'src/app/features/customer/models/CustomerReferential';
import { TranslationService } from '../../translations/services/translation.service';

@Component({
  selector: 'app-spec-dropdown',
  templateUrl: './spec-dropdown.component.html',
  styleUrls: ['./spec-dropdown.component.scss'],
  providers: [TranslationService],
  standalone: false
})
export class SpecDropdownComponent {
  @Input() id: string;
  @Input() formGroup: FormGroup;
  @Input() controlName: string;
  @Input() options: string[];
  @Input() optionsForCustomer: Referential[];
  @Input() editMode: boolean;
  @Input() label: string;
  @Input() placeholder: string;

  public translationService = inject(TranslationService);

  constructor() {}
}
